import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  faqs: localStorage.getItem('faqs') && JSON.parse(localStorage.getItem('faqs'))  || [],
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/faqs/index.js